import { getCache } from "./cache";
let token;

function setUtilsToken(t) {
  token = t;
}

async function sendRequest(url, method = 'GET', payload) {
  const headers = {
    "Content-Type": "application/json"
  };
  if (!token) {
    token = getCache('token');
  }
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const r = await fetch(url, {
    method: method,
    body: payload ? JSON.stringify(payload) : undefined,
    headers: headers
  });

  let data;
  try {
    data = await r.json();
  }
  catch (e) {
    try {
      data = await r.text();
    }
    catch (e) {
      data = r.statusText;
    }
  }

  console.log(r);
  if (r.ok) {
    if (r.status === 200) {
      return data;  
    }
  }
  else {
    throw {
      status: r.status,
      message: data.message,
      errors: data.errors
    }
  }
}

async function sendPost(token, url, payload) {
  return await sendRequest(url, 'POST', payload);
}

async function sendPostRequest(url, payload) {
  return await sendRequest(url, 'POST', payload);
}

async function sendGetRequest(url) {
  return await sendRequest(url, 'GET');
}

async function sendPut(url, payload) {
  return await sendRequest(url, 'PUT', payload);
}

async function sendDelete(url, payload) {
  return await sendRequest(url, 'DELETE', payload);
}

function renderRoles(roles) {
  let output = '';
  roles.forEach(r => {
    if (output) {
      output += ',';
    }
    output += r.role.label
  });
  return output
}

/**
 * 
 * @param {Date} date 
 * @param {string} format 
 * @returns {string}
 */
function formatDate(date, format) {
  function getDatePartAsTwoDigits(part) {
    if (part < 10) {
      return `0${part}`;
    }
    else {
      return `${part}`
    }
  }

  switch (format) {
    case 'yyyy-mm-dd':
      return `${date.getFullYear()}-${getDatePartAsTwoDigits(date.getMonth() + 1)}-${getDatePartAsTwoDigits(date.getDate())}`;
    default:
      return date.toString();
  }
}

function downloadCsvFile(fileName, content) {
  const universalBOM = "\uFEFF";
  const a = document.createElement('a');
  a.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + content);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * Function to check if an object has all required keys
 * @param {*} object The object to check
 * @param {String[]} keys The list of keys to check for
 * @returns {boolean}
 */
function hasAllKeys(object, keys) {
  return keys.every(key => Object.hasOwn(object, key));
};

/**
 * Finds keys present in the required keys array but missing from the target object.
 * @param {object} targetObj - The object to check for missing keys.
 * @param {string[]} requiredKeys - An array of all keys that should be present.
 * @returns {string[]} An array of keys missing from the target object.
 */
function findMissingKeys(targetObj, requiredKeys) {
  const targetKeys = Object.keys(targetObj);
  const missingKeys = requiredKeys.filter(key => {
    // Check if the required key is NOT in the target object's keys
    return !targetKeys.includes(key) || !targetObj[key] ;
  });
  return missingKeys;
}

function getToastErrorMessage(message, errors) {
  let errorMessage = <p>{message}</p>;
  if (errors && Object.keys(errors).length) {
    errorMessage = <>
      <p>{message} Por favor revisa lo siguiente:</p>
      <ul>
        {Object.keys(errors).map((key) => <li key={`error-${key}=${Date.now()}`}>{errors[key].msg}</li>)}
      </ul>
    </>
  }
  return errorMessage;
}

export {
  setUtilsToken,
  sendPost,
  sendPostRequest,
  sendGetRequest,
  sendPut,
  sendDelete,
  renderRoles,
  formatDate,
  downloadCsvFile,
  hasAllKeys,
  findMissingKeys,
  getToastErrorMessage
}